import { StandardDatePickerLabels } from '@brandfolder/react';

export const getStandardDatePickerLabels = (labels: Partial<StandardDatePickerLabels> = {}): StandardDatePickerLabels => {
  return {
    changeDate: bfTranslate('Change date'),
    chooseDate: bfTranslate('Choose date'),
    closeButton: bfTranslate('Close'),
    invalidDateError: bfTranslate('Invalid date'),
    label: bfTranslate('Due Date'),
    nextMonthButton: bfTranslate('Next month'),
    pastDateError: bfTranslate('Past date not allowed'),
    previousMonthButton: bfTranslate('Previous month'),
    requiredLabel: bfTranslate('Required'),
    ...labels
  };
};
